__turbopack_context__.v({
  "button": "EmptyCart-module__YC2ERa__button",
  "header": "EmptyCart-module__YC2ERa__header",
  "text": "EmptyCart-module__YC2ERa__text",
});
